module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSupimaMenu || _vm.isActiveWearMenu || _vm.isWinterWearMenu) ? _c('div', [_c('AppNav', {
    attrs: {
      "callerComp": _vm.isSupimaMenu ? 'supimaMenu' : _vm.isWinterWearMenu ? 'winterWearMenu' : 'activeWearMenu',
      "landingPageMenuData": _vm.isSupimaMenu ? _vm.supimaMenuData : _vm.activeWearMenuData,
      "handleMenu": _vm.handleMenu
    }
  }), _vm._v(" "), (_vm.isLandingPageSubMenu) ? _c('AppNav', {
    attrs: {
      "callerComp": _vm.isSupimaMenu ? 'supimaSubMenu' : 'activeWearSubMenu'
    }
  }) : _vm._e()], 1) : _c('div', [(_vm.showNewSideNavMenu) ? _c('newAppNav', {
    attrs: {
      "isDesktop": _vm.isDesktop
    }
  }) : _c('AppNav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-008aa27c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppNavLayout.vue
// module id = 2411
// module chunks = 41